import React from 'react';
import {
  Flex,
  PrimaryButton,
  Typography,
  Divider,
  useScreenSize,
} from '@banhala/ui-kit';
import { Image, View } from 'react-native';
import { isAndroid } from 'shared/src/utils';

type Props = {
  onPress: () => void;
};

const DeviceNotificationGuide = ({ onPress }: Props) => {
  const { width } = useScreenSize();
  const height = width * (128.0 / 343.0);

  return (
    <Flex.Column>
      <Typography type="h4" color="content_primary" marginBottom={6}>
        기기 알림을 켜세요
      </Typography>
      <Typography type="body2" color="content_tertiary" marginBottom={12}>
        정보 알림을 받기 위해서 기기 알림을 켜주세요
      </Typography>
      <Image
        source={
          isAndroid
            ? require('../../image/img_device_alarm_android.jpg')
            : require('../../image/img_device_alarm_ios.jpg')
        }
        style={{
          height: height,
          width: width - 32,
          borderRadius: 4,
          marginBottom: 20,
        }}
      />
      <PrimaryButton
        variant={'fill'}
        onPress={onPress}
        children={'기기 알림 켜기'}
        color="pink"
        size="xlarge"
      ></PrimaryButton>
      <View style={{ marginHorizontal: -16, marginTop: 12, marginBottom: 16 }}>
        <Divider size="medium" />
      </View>
    </Flex.Column>
  );
};

export default DeviceNotificationGuide;
